import React, { ChangeEvent } from "react";

/**
 * SearchInput Component
 * Consolidated styling using Tailwind component class (.input--search)
 *
 * REFACTOR NOTES:
 * - Replaced long className with .input--search from src/styles/components.css
 * - Added aria-label for accessibility (screen readers)
 * - Added id prop for label association
 * - Focus styles now managed in component class
 */
type SearchInputProps = {
  placeholder: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  id?: string; // For label association
  ariaLabel?: string; // Screen reader accessibility
  disabled?: boolean; // Support disabled state
};

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder,
  value,
  onChange,
  id,
  ariaLabel,
  disabled = false,
}) => {
  return (
    <input
      type="text"
      id={id}
      className={`input--search ${disabled ? "input--disabled" : ""}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      aria-label={ariaLabel || placeholder}
      disabled={disabled}
    />
  );
};

export default SearchInput;
